import type { CutsceneAssetV1 } from "@hyperlight/shared";

/**
 * SOUL kickoff ARRIVAL (docs/design/soul-kickoff.md, beat 1 — added 2026-07-23, user
 * call: creation must not drop straight into the fight): a short skippable descent
 * over the weaver cache before the crawl's first step. Authored cache-relative —
 * the anchor is the cache mouth, forward runs back along the APPROACH line toward
 * the landfall spawn (~90 m out), so the final frame settles behind the arriving
 * pilot looking at what they came for. The garrison waits at the cache; the fight
 * starts when the player closes, not at frame one.
 */
export const LANDFALL_CUTSCENE: CutsceneAssetV1 = {
  v: 1,
  id: "landfall-arrival-v1",
  duration: 12.5,
  skippable: true,
  camera: [
    { t: 0, position: [-90, 260, -160], target: [0, 10, 10], fov: 58, ease: "smooth" },
    { t: 4, position: [-40, 110, 20], target: [0, 6, 30], fov: 52, ease: "smooth" },
    { t: 8, position: [16, 34, 64], target: [0, 3, 52], fov: 48, ease: "smooth" },
    { t: 11, position: [5, 5.5, 101], target: [0, 1.8, 84], fov: 50, ease: "ease-out" },
    { t: 12.5, position: [3.5, 3.2, 98], target: [0, 1.6, 82], fov: 54, ease: "smooth" },
  ],
  cues: [
    { start: 0.8, end: 4.6, eyebrow: "{capital} OUTLANDS", text: "THE CACHE YOUR CREW BURIED" },
    { start: 5.6, end: 8.8, eyebrow: "INSIDE: A SOUL", text: "IT BINDS TO ONE HAND ONLY" },
    { start: 9.6, end: 12, eyebrow: "WEAVERS GOT HERE FIRST", text: "CLEAR THEM OUT" },
  ],
};
